import { Link, useNavigate } from 'react-router-dom';
import { Linkedin, Twitter, Mail } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const footerLinks = {
    services: [
      { name: 'Website Development', id: 'website-development', href: '/services/build' },
      { name: 'Mobile & App Development', id: 'mobile-app-development', href: '/services/build' },
      { name: 'Enterprise Software', id: 'enterprise-software', href: '/services/build' },
      { name: 'SAP & Salesforce', id: 'sap-salesforce', href: '/services/build' },
      { name: 'Hire Engineers', id: 'hire-engineers', href: '/services/hire' },
      { name: 'Product Consulting', id: 'product-consulting', href: '/services/consult' },
    ],
    company: [
      { name: 'About', href: '/about', id: 'about'},
      { name: 'How We Work', href: '', id: 'process' },
      { name: 'Our Work', href: '/ourwork', id: 'ourwork' },
      { name: 'Careers', href: '/careers', id: 'careers' },
      { name: 'Contact', href: '', id: 'contact' },
    ],
    legal: [
      { name: 'Privacy Policy', href: '/legal/privacy-policy' },
      { name: 'Terms & Conditions', href: '/legal/terms' },
      { name: 'Cookie Policy', href: '/legal/cookies' },
      { name: 'Impressum', href: '/legal/impressum' },
    ],
  };

    const scrollToSection = (id) => {
        const scrollAction = () => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
        };

        if (location.pathname === '/') {
        scrollAction();
        return;
        }

        navigate('/');
        setTimeout(scrollAction, 120);
    };

    return (
    <footer data-testid="main-footer" className="bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-16 lg:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block">
              <span className="text-lg lg:text-4xl font-bold tracking-tight">
                Build <span className="text-indigo-400">&</span> Hire
              </span>
            </Link>
            <p className="mt-4 text-slate-300 leading-relaxed max-w-sm text-[13px]">
              Building exceptional digital products and connecting companies with elite engineering talent — across Europe, the UK, North America, and APAC.
            </p>
            <div className="mt-6 flex items-center space-x-4">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-linkedin"
                className="p-2 rounded-full bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white transition-all"
              >
                <Linkedin className="h-5 w-5" strokeWidth={1.5} />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-twitter"
                className="p-2 rounded-full bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white transition-all"
              >
                <Twitter className="h-5 w-5" strokeWidth={1.5} />
              </a>
              <a
                href="mailto:masurkar.alpita@buildupriseup.com"
                data-testid="social-email"
                className="p-2 rounded-full bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white transition-all"
              >
                <Mail className="h-5 w-5" strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
                <h4 className="text-base font-bold uppercase tracking-wider mb-4">
                Services
                </h4>
                <ul className="space-y-3">
                {footerLinks.services.map((link) => (
                    <li key={link.id}>
                    <Link
                        to={link.href}
                        className="text-slate-300 hover:text-white transition-colors text-sm"
                    >
                        {link.name}
                    </Link>
                    </li>
                ))}
                </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-base font-bold uppercase tracking-wider mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => {

                if (link.id === 'contact') {
                    return (
                        <li key={link.href}>
                        <a href="mailto:hello@buildupriseup.com?subject=Contact%20Request%20from%20Website" data-testid="cta-contact"  className="text-slate-300 hover:text-white transition-colors text-sm">
                            {link.name}
                        </a>
                        </li>
                    )
                }
                else if (link.href) {
                    return (
                        <li key={link.href}>
                            <Link
                                to={link.href}
                                className="text-slate-300 hover:text-white transition-colors text-sm"
                            >
                                {link.name}
                            </Link>
                            </li>
                    )
                } else {
                    return (
                        <li key={link.href}>

                            <button
                                key={link.id}
                                type="button"
                                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                                onClick={() => scrollToSection(link.id)}
                                className="text-slate-300 hover:text-white transition-colors text-sm"
                            >
                                {link.name}
                            </button>
                        </li>
                    )
                }
              })}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-base font-bold uppercase tracking-wider mb-4">
              Legal
            </h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-slate-300 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-300">
            © {currentYear} Build & Hire. A Build Up Rise Up UG company. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2 text-sm text-slate-300">
              <span className="w-1 h-1 rounded-full bg-indigo-400"></span>
              <span className='text-xs text-slate-300'>GDPR Compliant</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-slate-300">
                <span className="w-1 h-1 rounded-full bg-indigo-400"></span>
            <span className="text-xs text-slate-300">EU Presence · Munich, Germany</span>

            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
